import { gql } from "@apollo/client";


export const getClientId = gql`
query login(
    $id: String
) {
  aatmsv4_users(where: {userid: {_eq: $id}}) {
    client {
      clientname
      clientsid
    }
  }
}
`
export const checkUser = gql`
query m_users_authoritycheck(
  $id: String
) {
  aatmsv4_managers(where: {managersid: {_eq: $id},active: {_eq: true}})
  {
  canedituser
  }
}
`
export const User = gql`
query da_edituser_list(
  $id: uuid,
  $Active: Boolean) {
  aatmsv4_users(order_by: {client: {clientname: asc}, fleet: {aircraft: asc}, email: asc}, where: {active: {_eq: $Active}, clientid: {_eq: $id}}) {
    client {
      clientname
      clientsid
    }
    fleet {
      aircraft
    }
    email
    active
    _crew
    _ground
    _simulator
    _aircraft
    _manager
    _optimiser
    _dataadmin
    userid
  }
}
`

export const ActiveUsers = gql`
mutation MyMutation(
  $id: String
  $Crew: Boolean
  $Aircraft: Boolean
  $Ground: Boolean
  $Simulator: Boolean
  $active: Boolean
) {
    update_aatmsv4_users(where: {userid: {_eq: $id}}, _set: {_aircraft: $Aircraft,
      _crew: $Crew, _ground: $Ground, _simulator: $Simulator, active: $active}) {
      returning {
        active
      }
    }
  }
`
export const ActiveUserCrew = gql`
mutation da_editUser_active_false(
  $id: String
  $active: Boolean
    ){
      update_aatmsv4_crews(where: {crewid: {_eq:$id}}, _set: {active: $active}) {
        returning {
        crewid
        }
        }
    }
`
export const ActiveUserGround = gql`
mutation da_editUser_active_false(
  $id: String
  $active: Boolean
    ){
      update_aatmsv4_groundinst(where: {userid: {_eq:$id}}, _set: {active: $active}) {
        returning {
        userid
        }
        }
    }
`
export const ActiveUserSimulator = gql`
mutation da_editUser_active_false(
  $id: String
  $active: Boolean
    ){
      update_aatmsv4_simulatorinst(where: {usersid: {_eq:$id}}, _set: {active: $active}) {
        returning {
        usersid
        }
        }
    }
`
export const ActiveUserAircraft = gql`
mutation da_editUser_active_false(
  $id: String
  $active: Boolean
    ){
      update_aatmsv4_aircraftinst(where: {usersid: {_eq:$id}}, _set: {active: $active}) {
        returning {
        managersid
        }
        }
    }
`


export const selectedUser = gql`
mutation DA_EDITUSER_OPTION2(
    $id: String
    $Crew: Boolean
    $Aircraft: Boolean
    $Ground: Boolean
    $Manager: Boolean
    $Simulator: Boolean
) {
    update_aatmsv4_aircraftinst(where: {usersid: {_eq: $id}}, _set: {active: $Aircraft}) {
    returning {
    usersid
    }
    }
    update_aatmsv4_crews(where: {crewid: {_eq: $id}}, _set: {active: $Crew}) {
    returning {
    crewid
    }
    }
    update_aatmsv4_groundinst(where: {userid: {_eq: $id}}, _set: {active: $Ground}) {
    returning {
    userid
    }
    }
    update_aatmsv4_managers(where: {managersid: {_eq: $id}}, _set: {active: $Manager}) {
    returning {
    managersid
    }
    }
    update_aatmsv4_simulatorinst(where: {usersid: {_eq: $id}}, _set: {active: $Simulator}) {
    returning {
    usersid
    }
    }
   }
`



export const aircraft_active = gql`
mutation DA_EDITUSER_OPTION2(
  $id: String
  $Aircraft: Boolean
) {
  update_aatmsv4_aircraftinst(where: {usersid: {_eq: $id}}, _set: {active: $Aircraft}) {
    returning {
    usersid
    }
    }
}
`
export const crew_active = gql`
mutation DA_EDITUSER_OPTION2(
  $id: String
  $Crew: Boolean
) {
  update_aatmsv4_crews(where: {crewid: {_eq: $id}}, _set: {active: $Crew}) {
    returning {
    crewid
    }
    }
}
`

export const ground_active = gql`
mutation DA_EDITUSER_OPTION2(
  $id: String
  $Ground: Boolean
) {
  update_aatmsv4_groundinst(where: {userid: {_eq: $id}}, _set: {active: $Ground}) {
    returning {
    userid
    }
    }
}
`
export const simulator_active = gql`
mutation DA_EDITUSER_OPTION2(
  $id: String
  $Simulator: Boolean
) {
  update_aatmsv4_simulatorinst(where: {usersid: {_eq: $id}}, _set: {active: $Simulator}) {
    returning {
    usersid
    }
    }
}
`
export const user_active = gql`
mutation MyMutation(
  $id: String
  $Crew: Boolean
  $Aircraft: Boolean
  $Ground: Boolean
  $Simulator: Boolean
  $active: Boolean
) {
    update_aatmsv4_users(where: {userid: {_eq: $id}}, _set: {_aircraft: $Aircraft,
         _crew: $Crew, _ground: $Ground, _simulator: $Simulator, active: $active}) {
      returning {
        active
      }
    }
  }
`
export const register_active = gql`
mutation MyMutation(
  $id: String
  $Crew: Boolean
  $Aircraft: Boolean
  $Ground: Boolean
  $Simulator: Boolean
) {
    update_aatmsv4_register(where: {userid: {_eq: $id}}, _set: {aircraft: $Aircraft, crew: $Crew, ground: $Ground, simulator: $Simulator}) {
      returning {
        userid
      }
    }
  }
  
`